import { ModeResourceHelper } from '@mode/shared/util-halogen';
import { ReportDomain } from '@mode/shared/contract-common';
import { ApiTypes, StateRecord, ReportTypes } from '@mode/shared/contract-common';

export interface ReportRunResource extends StateRecord, ApiTypes.ModeResource {
  externalLink: string;
  shareLink: string;
  parameters: any[];
  token: string;
  state: string;
  errorMessage: string;
  errorDetail: string;
  dataSourceId: string;
  created_at: string;
  localCreatedAt: string;
  startedAt: string;
  completedAt: string;
  share: string;
  link: string;
  embedLink: string;
  iframeLink: string;
  limit_selected: boolean;
  python_state: 'none' | 'submitted' | 'pending' | 'succeeded' | 'failed' | 'skipped'; // matching PYTHON_STATES in report_run_representer.rb
  form_fields: ReportTypes.ReportRunFormField[];
  errorCause?: ReportDomain.ReportRunFailCause;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ReportRunResourceHelpers {
  import isResource = ModeResourceHelper.isResource;

  export function hasCsvLink(resource: ReportRunResource): boolean {
    return isResource(resource) && resource.hasLink('content');
  }

  export function getCsvLink(resource: ReportRunResource): string {
    return (hasCsvLink(resource) && resource.links('content').href) || '';
  }

  export function canEmbed(resource: ReportRunResource): boolean {
    return isResource(resource) && resource.hasLink('embed');
  }

  export function hasCloneLink(resource: ReportRunResource): boolean {
    return isResource(resource) && resource.hasLink('clone');
  }

  export function cloneLink(resource: ReportRunResource): string {
    return (hasCloneLink(resource) && resource.links('clone').href) || '';
  }
}
